import React from 'react';
import { FormikProps } from 'formik';
import { NewHireProps } from '../../../models/arc-epi-props';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { NewHireFormValues } from '../models/new-hire-form-model';
import { PersonFieldsDisplay } from '../../../../account-info/components/read-only/person-fields-display';
import { MailingAddressDisplay } from '../../../../account-info/components/read-only/mailing-address-display';
import { PhonesDisplay } from '../../../../account-info/components/read-only/phones-display';
import { EmailsDisplay } from '../../../../account-info/components/read-only/emails-display';


interface Props {
    labelSetting: LabelSettingProps;
    newHireProps: NewHireProps;
    formProps: FormikProps<NewHireFormValues>;
    nonStip: boolean;
}
export function NewHireExternalPersonReview(props: Props) {

    const { labelSetting, formProps, newHireProps, nonStip } = props;
    const { values } = formProps;

    return (
        <>
            <p>{nonStip ? newHireProps?.nonStipExternalEmployeeMessage : newHireProps?.stipExternalEmployeeMessage}</p>

            <PersonFieldsDisplay
                labelSetting={labelSetting}
                values={values}
                dobMasked
            />
            <MailingAddressDisplay
                labelSetting={labelSetting}
                values={values}
            />

            <PhonesDisplay
                labelSetting={labelSetting}
                values={values}
            />

            <EmailsDisplay
                labelSetting={labelSetting}
                values={values}
            />

        </>
    );
}